export default __webpack_public_path__ + "static/mockCalendar3-49e5bbec0672a02b75654566db62fbe0.png";